module.exports = __webpack_public_path__ + "Floorplan_Studio_2.14cea36c.pdf";


//////////////////
// WEBPACK FOOTER
// ./client/download/Floorplan_Studio_2.pdf
// module id = 476
// module chunks = 0